/*
 *
 * CreateDivisionModal actions
 *
 */

import {
  GET_DIVISIONS_NO_PARENTS_SUCCESS,
  GET_DIVISIONS_NO_PARENTS_WATCHER,
  CREATE_DIVISION_WATCHER,
  CREATE_DIVISION_FAILED,
  CREATE_DIVISION_SUCCESS,
} from "./constants"

export function getSubdivisionsWithoutParentSuccess(payload) {
  return {
    type: GET_DIVISIONS_NO_PARENTS_SUCCESS,
    payload,
  }
}

export function getSubdivisionsWithoutParent() {
  return { type: GET_DIVISIONS_NO_PARENTS_WATCHER }
}

export const createDivisionWatcher = (payload) => {
  return {
    type: CREATE_DIVISION_WATCHER,
    payload,
  }
}

export const createDivisionSuccess = (payload) => {
  return {
    type: CREATE_DIVISION_SUCCESS,
    payload,
  }
}

export const createDivisionFailed = (payload) => {
  return {
    type: CREATE_DIVISION_FAILED,
    payload,
  }
}
